const MANUAL_FILE_NAME = 'AS 홈페이지 사용 설명서.pptx';

function GuidePanel() {
  return (
    <>
      <div className="guide-header">
        <h2>가이드라인</h2>
        <div className="guide-download">
          <a href={`${process.env.PUBLIC_URL}/${MANUAL_FILE_NAME}`} download={MANUAL_FILE_NAME}>
            <button type="button" className="secondary">
              AS 홈페이지 사용 설명서 다운로드
            </button>
          </a>
        </div>
      </div>
      <div className="guide-accordion">
        <details className="guide-item">
          <summary className="guide-summary">자주 발생하는 인버터 오류 메세지 대응</summary>
          <div className="guide-item-body guide-body">
            <ol className="guide-steps">
              <li>
                <strong>PV(DC) ovr / PV(DC) over voltage / PV(DC) 과전압</strong>
                <ul className="guide-substeps">
                  <li> 점검 사항 <br/> 태양광 과전압, 모듈 전압 or 접속반 전압 체크 <br/> 개방전압 검토 <br/> (온도에 의해 전압상승으로인한 오류일 수 있음)</li>
                </ul>
              </li>
              <li>
                <strong>PV(DC) uvr / PV(DC) under voltage / PV(DC) 저전압</strong>
                <ul className="guide-substeps">
                  <li> 점검 사항 <br/> 태양광 저전압, 모듈 전압 or 접속반 전압 체크 <br/> 개방전압 검토 <br/> (온도에 의해 전압하강으로인한 오류일 수 있음)</li>
                </ul>
                <ul className="guide-substeps">
                  <li> 조치 사항 <br/> <strong>낮시간 발생시</strong> 인버터 업체 불러야함 보드 불량일 확률 높음 </li>
                </ul>
              </li>
              <li>
                <strong>Line(AC) ovr / Line(AC) over valtage / Line(AC) 과전압</strong>
                <ul className="guide-substeps">
                  <li> 점검 사항 <br/> 한전 과전압, 한전 인입 전압 체크</li>
                </ul>
                <ul className="guide-substeps">
                  <li> 조치 사항 <br/> <strong>기준전압+10%이상</strong>일때 한전에 탭조절 요청 </li>
                </ul>
              </li>
              <li>
                <strong>Line(AC) uvr / Line(AC) under valtage / Line(AC) 저전압</strong>
                <ul className="guide-substeps">
                  <li> 점검 사항 <br/> 한전 저전압, 한전 인입 전압 체크 <br/> Line(AC)전압이 0일경우 차단기 확인 <br/>(차단기 불량혹은 과전류로 인한 트립일 수 있음) </li>
                </ul>
                <ul className="guide-substeps">
                  <li> 조치 사항 <br/> 1. <strong>기준전압-10%이상</strong>일때 한전에 탭조절 요청 <br/> 2. 차단기 OFF 후 ON으로, 역전력계전기가 달려있을경우(50kW 이상태양광) 역전력계전기가 동작해서 트립될 수 있음. - 역전력계전기 에러 리셋</li>
                </ul>
                <p className="guide-asterisk-note">
                  <strong>3, 4번 참고사항</strong> <br/> &#8251; 계통 과전압/저전압에 의한 탭조절은 요즘 신청서 접수(처리하는데 오래걸림) 및
                  수수료 납부 필요함.
                </p>
              </li>
              <li>
                <strong>Ground fault / 지락 / 누설전류 검출</strong>
                <ul className="guide-substeps">
                  <li> 점검 사항 <br/> 전기간선 확인 필요 </li>
                </ul>
                <ul className="guide-substeps">
                  <li> 조치 사항 <br/> 전기 업체 보내야함 </li>
                </ul>
              </li>
              <li>
                <strong>Over Temp. / 과열</strong>
                <ul className="guide-substeps">
                  <li> 점검 사항 <br/> 인버터 과열, 펜(Fan) 확인 <br/> 전기실 또는 인버터 환기계통 확인필요 </li>
                </ul>
              </li>
            </ol>
          </div>
        </details>
        <details className="guide-item">
          <summary className="guide-summary">인버터 고장시 대처방법</summary>
          <div className="guide-item-body guide-body">
            <ol className="guide-steps">
              <li>
                <strong>인버터 전원 꺼짐</strong>
                <ul className="guide-substeps">
                  <li> 점검 사항 <br/> DC 전압 확인 후 정상 전압이 나오면 인버터 불량 <br/> DC전압이 안나오면 모듈 어레이 확인 <br/> (접속반 메인차단기 &gt;&gt; 퓨즈 &gt;&gt;&gt; 모듈선) </li>
                </ul>
              </li>
              <li>
                <strong>발전은 되는데 발전량이 현저히 적을때</strong>
                <ul className="guide-substeps">
                  <li> 점검 사항 <br/> 주변 음영 확인, 태양광 각도 확인, 모듈 방향 확인 <br/> 접속반 휴즈 확인, 각종 단자대 결속상태 확인 <br/> <strong>모두 정상일때, 인버터 불량일 확률 높음.</strong></li>
                </ul>
              </li>
            </ol>
          </div>
        </details>
        <details className="guide-item">
          <summary className="guide-summary">점검 메세지 08 대응</summary>
          <div className="guide-item-body guide-body guide-body-large">
            <ol className="guide-steps">
              <li>
                <strong>인버터 뒤편의 모니터링함을 열어 주세요.</strong>
              </li>
              <li>
                <strong>차단기가 내려져 있는지 확인해 주세요.</strong>
              </li>
              <li>
                <strong>차단기가 내려져 있으면 차단기를 올린 뒤 5분 후 인버터를 확인해 주세요.</strong>
              </li>
              <li>
                <strong>차단기가 올라가 있으면 차단기 가운데 노란 버튼을 눌러 주세요.</strong>
                <ul className="guide-substeps">
                  <li>
                    <strong>차단기가 내려갈 경우</strong> 다시 차단기를 올리고 5분 후 인버터를 확인해 주세요.
                  </li>
                  <li>
                    <strong>차단기가 내려가지 않을 경우</strong> 아래 5번을 참고해 주세요.
                  </li>
                </ul>
              </li>
              <li>
                <strong>
                  한전 계량기함으로 이동하여, 계량기함 주변 아래의 흰색 박스나, 차단기함에 태양광이라고 표기된
                  차단기를 확인해 주세요.
                </strong>
                <ul className="guide-substeps">
                  <li>
                    <strong>흰색 박스 혹은 차단기함에 태양광이 있는 경우</strong> 흰색 차단기 박스에 누전 차단기가
                    내려져 있으면 차단기를 올린 후 5분 후 인버터를 확인해 주세요.
                  </li>
                  <li>
                    <strong>없는 경우</strong> 분전함 안의 태양광 차단기를 올린 뒤 5분 후 인버터를 확인해 주세요.
                  </li>
                </ul>
              </li>
            </ol>
          </div>
        </details>
      </div>
    </>
  );
}

export default GuidePanel;
